export default __webpack_public_path__ + "static/section2-handyman-a953ed26f143c0bfb2db4352a84fac73.jpeg";